'use client';

import { useReactQuerySubscription } from '@/hooks/use-react-query-subscription';

export function WebsocketProvider() {
  useReactQuerySubscription();

  return null;
}
